/*
Defines jspsych objects for instruction screens.
*/

import jsPsychHtmlButtonResponse from "@jspsych/plugin-html-button-response"; //jspsych contribution plugin, plays audio file and records responses
import jsPsychAudioMultiResponse from "@jspsych-contrib/plugin-audio-multi-response";
import { mediaAssets } from "../../.."; //media files
import i18next from "i18next";
import "../../../i18n/i18n";
import store from "store2"; //storing session data
import { startTimerGPT } from "../helpers/updateCountDown";

export const intro = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    return mediaAssets.audio.introductionAlpaca;
  },
  prompt: () => {
    return `
    <div class="tiger-gif-container">
      <div class="speechbubble">
        <h1 class="header">${i18next.t(
          "intro." + store.session.get("config").taskName + ".text1",
        )} </h1>
        <p class="text"> ${i18next.t(
          "intro." + store.session.get("config").taskName + ".text2",
        )} </p>
        <p class="text"> ${i18next.t(
          "intro." + store.session.get("config").taskName + ".text3",
        )} </p>

        
      </div>
      <img class="roam-tiger" src=${
        mediaAssets.images[store.session.get("displayImage")]
      } alt="tiger"/>
    </div>
    <div class="key-button"> ${i18next.t("navigation.continueButtonText", {
      input: `${i18next.t("terms.anyKey")}`,
      action: `${i18next.t("terms.continue")}`,
    })} </div>
  `;
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
  on_start: () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  },
};

export const endTrialAlpaca = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    return mediaAssets.audio.gameEnd;
  },
  prompt: () => {
    return `
      <div class="text-block">
        <h3> ${i18next.t("gameBreak.endScreen.text1")} </h3>
        <p class="intro-text"> ${i18next.t("gameBreak.endScreen.text2")} </p>
      </div>
      <div class="key-button"> ${i18next.t("gameBreak.endScreen.text3")} </div>
    `;
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
  on_start: () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  },
};

const keyboardInstructions = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    return mediaAssets.audio.instructionsAlpaca;
  },
  prompt: () => {
    return `
    <div class="jspsych-content-modified">
      <h2 class="title">${i18next.t("instructions.alpaca.text1")}</h2>
      <div class="row">
        <div class="instruction-boxes fade-in-1" id="panel1">
        <img src="${mediaAssets.images.keyboardNumbers}" alt="arrow keys">
          <p>${i18next.t("instructions.alpaca.text2")}</p>
        </div>
        <div class="instruction-boxes fade-in-1" id="panel2">
        <img src="${mediaAssets.images.keyboardEnter}" alt="arrow keys">
          <p>${i18next.t("instructions.alpaca.text3")}</p>
        </div>
        <div class="instruction-boxes fade-in-1" id="panel3">
        <img src="${mediaAssets.images.keyboardBackspace}" alt="arrow keys">
          <p>${i18next.t("instructions.alpaca.text4")}</p>
        </div>
      </div>
      <div class="key-button"> ${i18next.t("navigation.continueButtonText", {
        input: `${i18next.t("terms.anyKey")}`,
        action: `${i18next.t("terms.continue")}`,
      })} </div>
      
    </div>
    `;
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
};

const timeInstructions = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    return mediaAssets.audio.nullAudio;
  },
  prompt: () => {
    return `
      <div class="tiger-gif-container">
        <div class="speechbubble">
         <h3 class="header">${i18next.t("instructions.alpaca.text5")} </h3>
         <div class="text-image">
              <canvas id="canvas-timer-gpt" width="160" height="160" class="canvas-timer"></canvas>
              <p class="text"> ${i18next.t("instructions.alpaca.text6")} </p>
          </div>
         <p class="text"> ${i18next.t("instructions.alpaca.text7")} </p>
        </div>
        <img class="roam-tiger" src=${
          mediaAssets.images[store.session.get("displayImage")]
        } alt="tiger"/>
      </div>
      <div class="key-button"> ${i18next.t("navigation.continueButtonText", {
        input: `${i18next.t("terms.anyKey")}`,
        action: `${i18next.t("terms.continue")}`,
      })} </div>
    `;
  },
  on_load: () => {
    const step = 20;
    const updateInterval = Math.round(1000 / step);
    const totalTime = 30 * step; // Total time in seconds
    const canvas = document.getElementById("canvas-timer-gpt");
    const ctx = canvas.getContext("2d");
    let colorCodes = {
      info: {
        color: "green",
      },
      warning: {
        color: "orange",
        threshold: Math.floor(totalTime / 2),
        transitionEnd: Math.floor(totalTime / 2) - step,
      },
      alert: {
        color: "red",
        threshold: Math.floor(totalTime / 4),
        transitionEnd: Math.floor(totalTime / 4) - step,
      },
    };
    startTimerGPT(totalTime, updateInterval, ctx, canvas, colorCodes, step);
  },
  on_finish: () => {
    clearInterval(store.session.get("intervalId"));
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
  trial_duration: () => 30000, //wait 30 seconds before timeout
};

const preTaskReminder = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    return mediaAssets.audio.pretaskReminderAlpaca;
  },
  prompt: () => {
    let imageFile = mediaAssets.images.paperAndPencil;
    if (store.session.get("config").labId === "numberLab") {
      imageFile = mediaAssets.images.paperAndPencilCalculatorHorizontal;
    }
    return `
    <div class="jspsych-content-modified">
    <h2 class="title">${i18next.t("instructions.alpaca.text1")}</h2>
    <div class="row">
      <div class="single-box">
      
        <p>${i18next.t(
          "instructions.alpaca.text8-" + store.session.get("config").labId,
        )}</p>
        <img src="${imageFile}" alt="arrow keys">
      </div>
    </div>
    <div class="key-button"> ${i18next.t("instructions.alpaca.text9")} </div>
  </div>
  `;
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
  on_start: () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  },
};

export const instructions = {
  timeline: [keyboardInstructions, timeInstructions, preTaskReminder],
};
